<div class="pb-2">
  <mat-list>
    <mat-list-item *ngFor="let tag of data.detailedTags; trackBy: trackByTagId">
      <mat-checkbox
        class="example-margin"
        [checked]="tagSelectionService.selectedTags.includes(tag)"
        (change)="updateSelectedTags($event, tag)"
      >
        <span class="tag {{ tag.color }}">#{{ tag.fullPath }}</span>
      </mat-checkbox>
    </mat-list-item>
  </mat-list>
</div>
<bottom-sheet-controls
  (onSubmit)="_bottomSheetRef.dismiss()"
  [submitText]="'Done'"
  [cancelText]="null"
></bottom-sheet-controls>
